import { FolkAlignmentBrush } from '../folk-alignment-brush';
FolkAlignmentBrush.define();
export { FolkAlignmentBrush };
//# sourceMappingURL=folk-alignment-brush.js.map